// noinspection JSUnusedGlobalSymbols

/**
 * Controller for the authoring admin section
 */
define([
  "marionette",
  "backbone",
  "configuration/properties",
  "messaging/messenger",
  "./authoringAdminView",
  "./apiConfig/apiConfigModule",
  "./campaigns/campaignsModule",
  "./categories/categoriesModule",
  "./attributes/attributesModule",
  "./conversationVariablesAdmin/conversationVariablesAdminModule",
  "modules/shared/adminMenu/adminMenuModule",
  "./siteMaps/siteMapsModule",
  "./tableOfContents/tableOfContentsModule",
  "./topicListing/topicListingModule",
  "./authoringAdminModel",
], function (
  Marionette,
  Backbone,
  Properties,
  Messenger,
  AuthoringAdminView,
  ApiConfigModule,
  CampaignsModule,
  CategoriesModule,
  AttributesModule,
  ConversationVariablesAdminModule,
  AdminMenuModule,
  SiteMapsModule,
  TableOfContentsModule,
  TopicListingModule,
) {
  "use strict";

  const Router = Marionette.AppRouter.extend({
    appRoutes: {
      ":kbId/authoringAdmin": "_routeDefault",
      ":kbId/authoringAdmin/apis": "_routeApis",
      ":kbId/authoringAdmin/attributes": "_routeAttributes",
      ":kbId/authoringAdmin/campaigns": "_routeCampaigns",
      ":kbId/authoringAdmin/categories": "_routeCategories",
      ":kbId/authoringAdmin/conversationVariables": "_routeConversationVariables",
      ":kbId/authoringAdmin/siteMaps": "_routeSiteMaps",
      ":kbId/authoringAdmin/tableOfContents": "_routeTableOfContents",
      ":kbId/authoringAdmin/topicListing": "_routeTopicListing",
    },
  });

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "authoringAdmin";
      this.region = options.region;
      this._setUpVents();
      this.router = new Router({
        controller: this,
      });
    },
    show: function (subsection) {
      const kbId = Messenger.reqres.request("active:kb");
      Backbone.history.navigate(kbId + "/authoringAdmin");
      document.title = "Authoring Admin - " + Properties.applicationName;
      this.layout = new AuthoringAdminView.authoringAdminLayout();
      if (!subsection) {
        subsection = "apis";
      }
      this.subsection = subsection;

      this.menu = this.addSubModule(new AdminMenuModule({ region: this.layout.sideMenu }));
      this.apiAdmin = this.addSubModule(
        new ApiConfigModule({ region: this.layout.authoringAdmin }),
      );
      this.campaignAdmin = this.addSubModule(
        new CampaignsModule({ region: this.layout.authoringAdmin }),
      );
      this.categoryAdmin = this.addSubModule(
        new CategoriesModule({ region: this.layout.authoringAdmin }),
      );
      this.variableAdmin = this.addSubModule(
        new ConversationVariablesAdminModule({ region: this.layout.authoringAdmin }),
      );
      this.attributeAdmin = this.addSubModule(
        new AttributesModule({ region: this.layout.authoringAdmin }),
      );
      this.siteMapsAdmin = this.addSubModule(
        new SiteMapsModule({ region: this.layout.authoringAdmin }),
      );
      this.tableOfContentsAdmin = this.addSubModule(
        new TableOfContentsModule({ region: this.layout.authoringAdmin }),
      );
      this.topicListingAdmin = this.addSubModule(
        new TopicListingModule({ region: this.layout.authoringAdmin }),
      );

      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _showSubViews: async function () {
      const menuItems = await Messenger.reqres.request("authoring:admin:menu:items");
      const subsectionParts = this.subsection.split("/");
      let parentItems = menuItems;
      for (let subsectionPart of subsectionParts) {
        const currentItem = parentItems.findWhere({ name: subsectionPart });
        if (currentItem) {
          currentItem.set("default", true);
          parentItems = currentItem.get("children");
        }
      }
      const menuStyle = Messenger.reqres.request("authoring:admin:menu:style");
      this.menu.show(menuStyle, menuItems, "authoring:admin");
    },
    _route: function (kbId, subsection) {
      // If user isn't admin, kick 'em out!
      const isAdmin = Messenger.reqres.request("user:is:admin", kbId);
      if (!isAdmin) {
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      Messenger.command.execute("set:active:kb", kbId);
      this.show(subsection);
    },
    _routeApis: function (kbId) {
      this._route(kbId, "apis");
    },
    _routeAttributes: function (kbId) {
      this._route(kbId, "attributes");
    },
    _routeCategories: function (kbId) {
      this._route(kbId, "categories");
    },
    _routeCampaigns: function (kbId) {
      this._route(kbId, "campaigns");
    },
    _routeConversationVariables: function (kbId) {
      this._route(kbId, "conversationVariables");
    },
    _routeDefault: function (kbId) {
      this._route(kbId, "apis");
    },
    _routeSiteMaps: function (kbId) {
      this._route(kbId, "siteMaps");
    },
    _routeTableOfContents: function (kbId) {
      this._route(kbId, "tableOfContents");
    },
    _routeTopicListing: function (kbId) {
      this._route(kbId, "topicListing");
    },

    _setUpVents: function () {
      Messenger.vent.on(
        "show:authoring:admin",
        function (subsection) {
          this.show(subsection);
        },
        this,
      );
    },
  });
});
